var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSsfSortIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "SSF_Sort_Icon",
    d: "M9.5,19A9.5,9.5,0,1,1,19,9.5,9.511,9.511,0,0,1,9.5,19ZM4.092,13.785a.8.8,0,0,0,0,1.593h5.73a1.817,1.817,0,0,0,3.264,0h1.589a.8.8,0,1,0,0-1.593H13.088a1.816,1.816,0,0,0-3.264,0ZM3.776,7.311a.776.776,0,0,0-.549,1.325l1.791,1.791a1.5,1.5,0,0,0,2.128,0L8.9,8.672a.776.776,0,1,0-1.1-1.1l-.964.963V4.023a.776.776,0,0,0-1.552,0V8.5l-.964-.964A.771.771,0,0,0,3.776,7.311Zm8.152-1.944V9.845a.776.776,0,0,0,1.552,0V5.332l.964.964a.777.777,0,0,0,1.1-1.1L13.785,3.441a1.5,1.5,0,0,0-2.128,0L9.867,5.232a.776.776,0,1,0,1.1,1.1l.962-.961Z",
    fill: "#243746"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsfSortIcon);
export default __webpack_public_path__ + "static/media/SSF_Sort_Icon.a089d5ba.svg";
export { ForwardRef as ReactComponent };